
















































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import FieldSelectModal from '@/app/components/MachineRent/FieldSelectModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
import NoticeModal from '@/app/components/Common/NoticeModal.vue'
/* api */
import MachineRentDetailApi from '@/app/model/api/machineRentDetailApi'
import MachineRentCreateApi from '@/app/model/api/machineRentCreateApi'
import MachineRentEditApi from '@/app/model/api/machineRentEditApi'
import MachineRentDeleteApi from '@/app/model/api/machineRentDeleteApi'
import MasterFieldListApi from '@/app/model/api/masterFieldListApi'
import MachineListApi from '@/app/model/api/machineListApi'
import AccountListApi from '@/app/model/api/accountListApi'
import { gmapApi } from 'vue2-google-maps'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import Session from '@/app/module/session'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorInfo,
    ErrorModal,
    Error409Modal,
    DeleteModal,
    Loading,
    FieldSelectModal,
    ConfirmModal,
    NoticeModal
  }
})
export default class MachineRentCreate extends Vue {
  private errorMessages: any = {}
  private alertText: string = ''
  private alertTitle: string = ''
  private constantValue: any = []
  private machineType: number|null = null
  private machineRentData: any = {
    field_id: null,
    machine_id: null,
    remarks: '',
    role: {
      role_reception: null,
      role_send: null,
      role_machine_operator: null,
      role_return: null,
      role_maintenance: null,
      role_house_manage: null
    },
    send: {
      send_name: '',
      send_zip_code: '',
      send_prefecture: '',
      send_address1: '',
      send_address2: '',
      send_tell: '',
      send_mailaddress: ''
    },
    billing: {
      billing_name: '',
      billing_zip_code: '',
      billing_prefecture: '',
      billing_address1: '',
      billing_address2: '',
      billing_tell: '',
      billing_mailaddress: ''
    }
  }
  private machineRentSteps: any = [
    {
      step: 1,
      date: ''
    },
    {
      step: 2,
      date: ''
    },
    {
      step: 3,
      date: ''
    },
    {
      step: 4,
      date: ''
    },
    {
      step: 5,
      date: ''
    },
    {
      step: 6,
      date: ''
    },
    {
      step: 7,
      date: ''
    }
  ]
  private masterFieldData: any = []
  private machineData: any = []
  private rentPlans: any = []
  private fieldCount: number = 0
  private machineTypeName: string = ''
  private groupName: string = ''
  private fieldName: string = ''
  private selectedFieldId: number|null = null
  private accountData: any = []
  /* 表示非表示 */
  private isEdit: boolean = false
  private isInitialDisplay: boolean = true
  private show400ErrorMessage: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private showSendLoading: boolean = false
  private showBillingLoading: boolean = false
  private showError409Modal: boolean = false
  private showFieldSelectModal: boolean = false
  /* v-calender */
  private timezone: string = ''

  created () {
    // セレクトボックス情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getAccountList()

    if (this.$route.path === '/machine-rent/create') {
      this.getMasterFieldList()
      this.getMachineList()
      this.isEdit = false
      this.createRentPlan('create')
    } else {
      this.getDefultMasterFieldList()
      this.isEdit = true
    }
  }

  destroyed () {
    this.$store.commit('machineRentState/setInitialFieldId', null)
  }

  private judgmentStepName (step: number) {
    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].step_name
      }
    }
  }

  private judgmentStatusName (step: number) {
    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].status_name
      }
    }
  }

  private dateToStringMd (date: any, unit: string) {
    if (date !== null && date !== '') {
      return DateClass.dateToStringMd(new Date(date), unit)
    } else {
      return ''
    }
  }

  private geocoder: any

  mounted () {
    const vueComponents: any = this
    vueComponents.$gmapApiPromiseLazy().then(() => { this.geocoder = new google.maps.Geocoder() })
  }

  private getPrefecture (address: any) {
    let prefecture = address.filter(function (data: any) {
      return (data.types.includes('administrative_area_level_1'))
    })
    return prefecture[0]['long_name']
  }

  private getAddress (data: any) {
    const address1 = data.filter(function (data: any) {
      return (data.types.includes('administrative_area_level_2'))
    })
    const address2 = data.filter(function (data: any) {
      return (data.types.includes('locality'))
    })
    const address3 = data.filter(function (data: any) {
      return (data.types.includes('sublocality_level_1'))
    })
    const address4 = data.filter(function (data: any) {
      return (data.types.includes('sublocality_level_2'))
    })
    const addressArray = address1.concat(address2).concat(address3).concat(address4)

    let address = ''
    for (let i in addressArray) {
      address = address + addressArray[i]['long_name']
    }
    return address
  }

  private async doSerchAddress (type: string) {
    let zipCode = ''
    if (type === 'send') {
      this.showSendLoading = true
      zipCode = this.machineRentData.send.send_zip_code
    } else {
      this.showBillingLoading = true
      zipCode = this.machineRentData.billing.billing_zip_code
    }
    const vueComponents: any = this
    await this.geocoder.geocode({ 'address': zipCode }, function (results: any, status: any) {
      if (status === google.maps.GeocoderStatus.OK) {
        let addressData = results[0].address_components
        if (addressData.length < 4) {
          if (type === 'send') {
            vueComponents.errorMessages.sendZipCodeErrorMessage = '正しい郵便番号を入力してください'
          } else {
            vueComponents.errorMessages.billingZipCodeErrorMessage = '正しい郵便番号を入力してください'
          }
        } else {
          if (type === 'send') {
            vueComponents.machineRentData.send.send_prefecture = vueComponents.getPrefecture(addressData)
            vueComponents.machineRentData.send.send_address1 = vueComponents.getAddress(addressData)
            vueComponents.errorMessages.sendZipCodeErrorMessage = ''
          } else {
            vueComponents.machineRentData.billing.billing_prefecture = vueComponents.getPrefecture(addressData)
            vueComponents.machineRentData.billing.billing_address1 = vueComponents.getAddress(addressData)
            vueComponents.errorMessages.billingZipCodeErrorMessage = ''
          }
        }
      } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
        if (type === 'send') {
          vueComponents.errorMessages.sendZipCodeErrorMessage = '該当する住所が見つかりませんでした。'
        } else {
          vueComponents.errorMessages.billingZipCodeErrorMessage = '該当する住所が見つかりませんでした。'
        }
      } else {
        if (type === 'send') {
          vueComponents.errorMessages.sendZipCodeErrorMessage = '住所検索に失敗しました。'
        } else {
          vueComponents.errorMessages.billingZipCodeErrorMessage = '住所検索に失敗しました。'
        }
      }

      // ローディング非表示
      if (type === 'send') {
        vueComponents.showSendLoading = false
      } else {
        vueComponents.showBillingLoading = false
      }
    })
  }

  // 生産者情報取得
  private getAccountList () {
    (async () => {
      const data = {
        type: 0,
        text: '',
        order_name: 'name',
        sort: 'asc'
      }

      const result = await AccountListApi.getAccountList(data)

      if (result.isOk()) {
        this.accountData = result.getPayload().users
        if (result.getPayload().total_user === 0) {
          this.alertText = ''
          this.alertTitle = '生産者が未登録です。生産者を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private createRentPlan (key: string) {
    let rentPlans = []

    // 編集画面は詳細取得APIをそのまま表示
    if (key === 'edit') {
      for (let j in this.constantValue.machine_steps) {
        const stepData = this.machineRentSteps.filter((item: any) => item.step === this.constantValue.machine_steps[j].step)
        rentPlans.push({
          step: this.constantValue.machine_steps[j].step,
          step_name: this.constantValue.machine_steps[j].step_name,
          status_name: this.constantValue.machine_steps[j].status_name,
          date: new Date(stepData[0].plan_date),
          plan_days: stepData[0].plan_days,
          plan_time: stepData[0].plan_time
        })
      }

      this.rentPlans = rentPlans
      return
    }

    // 追加画面は今日の日時を表示
    const nowDate = new Date().setMinutes(0, 0, 0)
    for (let i in this.constantValue.machine_steps) {
      for (let j in this.machineRentSteps) {
        if (this.constantValue.machine_steps[i].step === this.machineRentSteps[j].step) {
          rentPlans.push({
            step: this.constantValue.machine_steps[i].step,
            step_name: this.constantValue.machine_steps[i].step_name,
            status_name: this.constantValue.machine_steps[i].status_name,
            date: new Date(nowDate),
            plan_days: 0,
            plan_time: 0
          })
        }
      }
    }
    this.rentPlans = rentPlans
  }

  private addDate (step: number) {
    // 押下したstep以降に1日追加
    const copy = JSON.parse(JSON.stringify(this.rentPlans))
    for (let i in copy) {
      copy[i].date = new Date(copy[i].date)
      if (copy[i].step > step) {
        copy[i].date.setDate(copy[i].date.getDate() + 1)
      }
    }
    this.rentPlans = copy
    this.calcDate()
  }

  private addHour (step: number) {
    // 押下したstep以降に1時間追加
    const copy = JSON.parse(JSON.stringify(this.rentPlans))
    for (let i in copy) {
      copy[i].date = new Date(copy[i].date)
      if (copy[i].step > step) {
        copy[i].date.setHours(copy[i].date.getHours() + 1)
      }
    }
    this.rentPlans = copy
    this.calcDate()
  }

  private calcDate () {
    const copy = JSON.parse(JSON.stringify(this.rentPlans))
    for (let i in copy) {
      copy[i].date = new Date(copy[i].date)
      if (i > '0') {
        // 日差分を計算
        const termDay = (copy[i].date - copy[parseInt(i) - 1].date) / 86400000
        copy[i].plan_days = Math.floor(termDay)
        // 時間差分を計算
        const termDate = copy[i].date.getTime() - copy[parseInt(i) - 1].date.getTime()
        copy[i].plan_time = termDate / (60 * 60 * 1000) % 24
      }
    }
    this.rentPlans = copy
  }

  private getMachineList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'machine_name',
        sort: true,
        is_valid: null,
        machine_type: null
      }

      const result = await MachineListApi.getMachineList(data)

      if (result.isOk()) {
        const machineData = result.getPayload().results
        const isValidMachineData = machineData.filter((data: any) => data.is_valid === 0)
        if (this.isEdit) {
          const selectedMachineData = isValidMachineData.filter((data: any) => data.machine_id === this.machineRentData.machine_id)
          if (selectedMachineData.length === 0) {
            // 選択されている利用不可を追加
            const machineIdData = machineData.filter((data: any) => data.machine_id === this.machineRentData.machine_id)
            machineIdData[0].machine_name = machineIdData[0].machine_name + ' (利用不可)'
            this.machineData = isValidMachineData.concat(machineIdData)
          } else {
            // 利用可のみ表示
            this.machineData = isValidMachineData
          }
        } else {
          // 利用可のみ表示
          this.machineData = isValidMachineData
          if (this.$store.state.machineRentState.initialFieldId !== null) {
            // 除草警報一覧空の遷移の場合は初期値は一つ目の除草機械
            let weedingData = machineData.filter((data: any) => data.machine_type === this.judgmentMachineTypeId('除草'))
            if (weedingData.length !== 0) {
              this.machineRentData.machine_id = weedingData[0].machine_id
              this.machineTypeName = '除草'
            }
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  /* 機械タイプの判定 */
  private judgmentMachineTypeId (typeName: string) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_name === typeName) {
        return this.constantValue.machine_types[i].machine_type_id
      }
    }
  }

  private getDefultMasterFieldList () {
    (async () => {
      const data = {
        word: '',
        sensor_word: '',
        order_name: 'field_name',
        sort: true,
        page: 1
      }

      const result = await MasterFieldListApi.getMasterFieldList(data)

      if (result.isOk()) {
        this.getMachineRentList()
        this.masterFieldData = result.getPayload().results
        this.fieldCount = result.getPayload().total_count
        if (this.isInitialDisplay && this.fieldCount === 0) {
          this.alertText = ''
          this.alertTitle = '圃場が未登録です。圃場を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.isInitialDisplay = false
      this.showLoading = false
    })()
  }

  private getMasterFieldList () {
    (async () => {
      const data = {
        word: this.$store.state.machineRentState.fieldSearchText,
        sensor_word: '',
        order_name: this.$store.state.machineRentState.fieldOrderName,
        sort: this.$store.state.machineRentState.fieldSortAsc,
        page: this.$store.state.machineRentState.fieldCurrentPage
      }

      const result = await MasterFieldListApi.getMasterFieldList(data)

      if (result.isOk()) {
        this.masterFieldData = result.getPayload().results
        if (this.isInitialDisplay && this.$store.state.machineRentState.initialFieldId !== null) {
          // 除草警報一覧空の遷移の場合は圃場をセット
          this.machineRentData.field_id = this.$store.state.machineRentState.initialFieldId
          this.judgmentFieldName(this.$store.state.machineRentState.initialFieldId)
          this.selectedFieldId = this.$store.state.machineRentState.initialFieldId
        }
        this.fieldCount = result.getPayload().total_count
        if (this.isInitialDisplay && this.fieldCount === 0) {
          this.alertText = ''
          this.alertTitle = '圃場が未登録です。圃場を登録してから作付けを追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.isInitialDisplay = false
    })()
  }

  private closeDeleteModal () {
    this.showDeleteModal = false
  }

  // リクエスト用
  private ceateStringYmd (date: any) {
    if (date !== null) {
      const formingDate = DateClass.toDoubleDigits(date.getFullYear()) + '-' + DateClass.toDoubleDigits(date.getMonth() + 1) + '-' + DateClass.toDoubleDigits(date.getDate())
      return formingDate
    }
  }

  // 表示用
  private ceateStringYmd2 (date: any) {
    if (date !== null) {
      const formingDate = DateClass.toDoubleDigits(date.getFullYear()) + '年' + DateClass.toDoubleDigits(date.getMonth() + 1) + '月' + DateClass.toDoubleDigits(date.getDate()) + '日'
      return formingDate
    }
    return ''
  }

  /* 機械タイプの判定 */
  private judgmentMachineType (id: number) {
    // 機械情報を取得
    const machineData = this.machineData.filter((item: any) => item.machine_id === id)
    if (machineData[0] === undefined) {
      return
    }
    this.judgmentMachineTypeName(machineData[0].machine_type)
  }

  /* 機械タイプ名の判定 */
  private judgmentMachineTypeName (type: number) {
    // 機械タイプ情報を取得
    const machineType = this.constantValue.machine_types.filter((item: any) => item.machine_type_id === type)
    if (machineType[0] === undefined) {
      return
    }
    this.machineTypeName = machineType[0].machine_type_name
  }

  /* グループ名の判定 */
  private judgmentGroupName (fieldId: number) {
    const fieldData = this.masterFieldData.filter((item: any) => item.field_id === fieldId)
    if (fieldData[0] === undefined) {
      return
    }
    this.groupName = fieldData[0].group_name
  }

  /* 圃場名の判定 */
  private judgmentFieldName (fieldId: number) {
    this.judgmentGroupName(fieldId)
    const fieldData = this.masterFieldData.filter((item: any) => item.field_id === fieldId)
    if (fieldData[0] === undefined) {
      return
    }
    this.fieldName = fieldData[0].field_name
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.doValidate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    const machineRentSteps = []
    for (let i in this.rentPlans) {
      machineRentSteps.push({
        step: this.rentPlans[i].step,
        plan_date: DateClass.dateToStringYmdhm(this.rentPlans[i].date, '-')
      })
    }

    const data: any = {
      machine_rent: {
        field_id: this.machineRentData.field_id,
        machine_id: this.machineRentData.machine_id,
        remarks: this.machineRentData.remarks,
        role: this.machineRentData.role,
        send: this.machineRentData.send,
        billing: this.machineRentData.billing
      },
      machine_rent_steps: machineRentSteps
    }

    // 郵便番号に-がない場合、-を追加
    if (!this.machineRentData.billing.billing_zip_code.match(/^[0-9]{3}-[0-9]{4}$/)) {
      let a = this.machineRentData.billing.billing_zip_code.slice(0, 3)
      let b = this.machineRentData.billing.billing_zip_code.slice(3)
      this.machineRentData.billing.billing_zip_code = a + '-' + b
    }
    if (this.machineRentData.send.send_zip_code && !this.machineRentData.send.send_zip_code.match(/^[0-9]{3}-[0-9]{4}$/)) {
      let a = this.machineRentData.send.send_zip_code.slice(0, 3)
      let b = this.machineRentData.send.send_zip_code.slice(3)
      this.machineRentData.send.send_zip_code = a + '-' + b
    }

    if (this.isEdit) {
      data.machine_rent.time_stamp = this.machineRentData.time_stamp
      this.doEdit(data)
    } else {
      this.doCreate(data)
    }
  }

  private getMachineRentList () {
    (async () => {
      const result = await MachineRentDetailApi.getMachineRentDetail(this.$route.params.machine_rent_id)
      if (result.isOk()) {
        this.getMachineList()
        this.machineRentData = result.getPayload().machine_rent
        this.machineRentSteps = result.getPayload().machine_rent_steps
        this.selectedFieldId = this.machineRentData.field_id
        // 表示のみ項目の値を取得
        this.judgmentMachineTypeName(this.machineRentData.machine_type)
        this.judgmentFieldName(this.machineRentData.field_id)
        this.createRentPlan('edit')
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private async doCreate (body: any) {
    const result = await MachineRentCreateApi.doMachineRentCreate(body)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械貸出登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/machine-rent').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async doEdit (body: any) {
    const result = await MachineRentEditApi.doMachineRentEdit(this.$route.params.machine_rent_id, body)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械貸出編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/machine-rent/' + this.$route.params.machine_rent_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private doValidate () {
    // リセット
    this.errorMessages = {}

    Validator.validateInputMachineName('machineNameErrorMessage', this.machineRentData.machine_id)
    Validator.validateInputFieldName('fieldNameErrorMessage', this.machineRentData.field_id)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true
    /* 貸出予定 */
    for (let i in this.rentPlans) {
      if (i !== '0' && this.rentPlans[i].date < this.rentPlans[parseInt(i) - 1].date) {
        this.$set(this.errorMessages, 'dateErrorMessage', '予定日時は前のステップ予定日時以降で入力してください。')
        isError = false
      }
    }

    /* 担当者 */
    if (this.machineRentData.role.role_reception === null) {
      this.$set(this.errorMessages, 'roleReceptionErrorMessage', '受付は必ず入力してください。')
    }
    if (this.machineRentData.role.role_send === null) {
      this.$set(this.errorMessages, 'roleSendErrorMessage', '配送は必ず入力してください。')
    }
    if (this.machineRentData.role.role_machine_operator === null) {
      this.$set(this.errorMessages, 'roleMachineOperatorErrorMessage', '機械オペレーターは必ず入力してください。')
    }
    if (this.machineRentData.role.role_return === null) {
      this.$set(this.errorMessages, 'roleReturnErrorMessage', '返送は必ず入力してください。')
    }
    if (this.machineRentData.role.role_maintenance === null) {
      this.$set(this.errorMessages, 'roleMaintenanceErrorMessage', '保守は必ず入力してください。')
    }
    if (this.machineRentData.role.role_house_manage === null) {
      this.$set(this.errorMessages, 'roleHouseManageErrorMessage', '保守は必ず入力入庫管理は必ず入力してください。してください。')
    }

    /* 請求先 */
    // 宛名
    if (this.machineRentData.billing.billing_name === '') {
      this.$set(this.errorMessages, 'billingNameErrorMessage', '宛名は必ず入力してください。')
    } else if (this.machineRentData.billing.billing_name.length > 100) {
      this.$set(this.errorMessages, 'billingNameErrorMessage', '宛名は100文字以下で入力してください。')
    }
    // 郵便番号
    if (this.machineRentData.billing.billing_zip_code === '') {
      this.$set(this.errorMessages, 'billingZipCodeErrorMessage', '郵便番号は必ず入力してください。')
    } else if (this.machineRentData.billing.billing_zip_code.length > 8) {
      this.$set(this.errorMessages, 'billingZipCodeErrorMessage', '郵便番号は8文字以下で入力してください。')
    }
    // 都道府県
    if (this.machineRentData.billing.billing_prefecture === '') {
      this.$set(this.errorMessages, 'billingPrefectureErrorMessage', '都道府県は必ず入力してください。')
    } else if (this.machineRentData.billing.billing_prefecture.length > 10) {
      this.$set(this.errorMessages, 'billingPrefectureErrorMessage', '都道府県は10文字以下で入力してください。')
    }
    // 市区町村番地
    if (this.machineRentData.billing.billing_address1 === '') {
      this.$set(this.errorMessages, 'billingAddress1ErrorMessage', '市区町村番地は必ず入力してください。')
    } else if (this.machineRentData.billing.billing_address1.length > 100) {
      this.$set(this.errorMessages, 'billingAddress1ErrorMessage', '市区町村番地は100文字以下で入力してください。')
    }
    // 建物名など
    if (this.machineRentData.billing.billing_address2 &&
        this.machineRentData.billing.billing_address2.length > 100) {
      this.$set(this.errorMessages, 'billingAddress2ErrorMessage', '建物名などは100文字以下で入力してください。')
    }
    // 電話番号
    if (this.machineRentData.billing.billing_tell) {
      if (!(this.machineRentData.billing.billing_tell.match(/^[\d-]*$/))) {
        this.$set(this.errorMessages, 'billingTellErrorMessage', '電話番号は数字と-で入力してください。')
      } else if (this.machineRentData.billing.billing_tell.length > 13) {
        this.$set(this.errorMessages, 'billingTellErrorMessage', '電話番号は13文字以下で入力してください。')
      }
    }
    // メールアドレス
    if (this.machineRentData.billing.billing_mailaddress) {
      if (this.machineRentData.billing.billing_mailaddress.length > 100) {
        this.$set(this.errorMessages, 'billingMailaddressErrorMessage', 'メールアドレスは100文字以下で入力してください。')
      } else if (this.machineRentData.billing.billing_mailaddress.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/) === null) {
        this.$set(this.errorMessages, 'billingMailaddressErrorMessage', '正しいメールアドレスの形式で入力してください。')
      }
    }

    /* 配送先 */
    // 宛名
    if (this.machineRentData.send.send_name === '') {
      this.$set(this.errorMessages, 'sendNameErrorMessage', '宛名は必ず入力してください。')
    } else if (this.machineRentData.send.send_name.length > 100) {
      this.$set(this.errorMessages, 'sendNameErrorMessage', '宛名は100文字以下で入力してください。')
    }
    // 郵便番号
    if (this.machineRentData.send.send_zip_code) {
      if (this.machineRentData.send.send_zip_code.length > 8) {
        this.$set(this.errorMessages, 'sendZipCodeErrorMessage', '郵便番号は8文字以下で入力してください。')
      }
    }
    // 都道府県
    if (this.machineRentData.send.send_prefecture &&
        this.machineRentData.send.send_prefecture.length > 10) {
      this.$set(this.errorMessages, 'sendPrefectureErrorMessage', '都道府県は10文字以下で入力してください。')
    }
    // 市区町村番地
    if (this.machineRentData.send.send_address1 &&
        this.machineRentData.send.send_address1.length > 100) {
      this.$set(this.errorMessages, 'sendAddress1ErrorMessage', '市区町村番地は100文字以下で入力してください。')
    }
    // 建物名など
    if (this.machineRentData.send.send_address2 &&
        this.machineRentData.send.send_address2.length > 100) {
      this.$set(this.errorMessages, 'sendAddress2ErrorMessage', '建物名などは100文字以下で入力してください。')
    }
    // 電話番号
    if (this.machineRentData.send.send_tell) {
      if (!(this.machineRentData.send.send_tell.match(/^[\d-]*$/))) {
        this.$set(this.errorMessages, 'sendTellErrorMessage', '電話番号は数字と-で入力してください。')
      } else if (this.machineRentData.send.send_tell.length > 13) {
        this.$set(this.errorMessages, 'sendTellErrorMessage', '電話番号は13文字以下で入力してください。')
      }
    }
    // メールアドレス
    if (this.machineRentData.send.send_mailaddress) {
      if (this.machineRentData.send.send_mailaddress.length > 100) {
        this.$set(this.errorMessages, 'sendMailaddressErrorMessage', 'メールアドレスは100文字以下で入力してください。')
      } else if (this.machineRentData.send.send_mailaddress.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/) === null) {
        this.$set(this.errorMessages, 'sendMailaddressErrorMessage', '正しいメールアドレスの形式で入力してください。')
      }
    }

    for (let j in this.errorMessages) {
      if (this.errorMessages[j] !== '') {
        isError = false
      }
    }

    return isError
  }

  private doDelete () {
    (async () => {
      this.showLoading = true
      const result = await MachineRentDeleteApi.doMachineRentDelete(this.$route.params.machine_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械貸出を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/machine-rent').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private doSelectField () {
    this.showFieldSelectModal = true
  }

  private closeFieldSelectModal () {
    this.showFieldSelectModal = false
  }

  private getSelectedField (data: any) {
    this.showFieldSelectModal = false
    this.machineRentData.field_id = data.field_id
    this.selectedFieldId = data.field_id
    this.judgmentFieldName(data.field_id)
  }
  private doCancel () {
    if (this.isEdit) {
      this.$router.push('/machine-rent/' + this.$route.params.machine_rent_id).catch(e => {})
    } else {
      this.$router.push('/machine-rent').catch(e => {})
    }
  }
}
